import { withParams } from "vuelidate";
export default (function (patterns, minimum) {
    if (minimum === void 0) { minimum = 1; }
    return withParams({ type: 'regexSet', minimum: minimum, patterns: patterns }, function (value, parentVM) {
        if (!value)
            return true;
        var sPatterns = typeof patterns === "function" ? patterns.call(this) : patterns;
        var nMinimum = typeof minimum === "function" ? minimum.call(this) : minimum;
        var count = sPatterns
            .map(function (p) { return new RegExp(p).test(value); })
            .filter(function (p) { return p; })
            .length;
        return count >= nMinimum;
    });
});



//////////////////
// WEBPACK FOOTER
// ./src/Validators/regexSet.ts
// module id = 965
// module chunks = 24